'use strict';

var showAngularStats = require('ng-stats');
var KeyboardSupportConfig = function KeyboardSupportConfig(hotkeys, $document) {
  // https://github.com/kentcdodds/ng-stats
  hotkeys.add({
    combo: 'shift+ctrl+alt+a',
    description: 'Show ng-stats monitor',
    callback: function callback() {
      var chartOptions = {
        position: 'bottom-right',
        digestTimeThreshold: 25,
        autoload: false,
        trackDigest: true,
        trackWatches: true,
        logDigest: true,
        logWatches: true
      };
      showAngularStats(chartOptions);
    }
  });
  $document.on('keydown', function (evt) {
    if (!!~[38, 40].indexOf(evt.which)) {
      evt.preventDefault();
      return true;
    }
  });
};
KeyboardSupportConfig.$inject = ['hotkeys', '$document'];
module.exports = KeyboardSupportConfig;